import React, { Component } from 'react';
import { connect } from 'dva';
import Container from '@/components/Container';
import Iframe from '@/components/Iframe';
import { NEW_RDP_PUBLIC_URL } from '@/utils/utils';

@connect(({ user }) => ({
  ...user,
}))
class List extends Component {
  render() {
    const { orgId } = this.props.currentUser;

    if (!orgId) {
      return null
    }

    const IframeDom = Iframe({
      src: `${NEW_RDP_PUBLIC_URL}/befe78f34e96f5d4c9169b0890348310?orgId=${orgId}`,
    });

    return (
      <Container breStates defaultPadding>
        <div style={{padding: '9px 17px'}}>
          <IframeDom />
        </div>
      </Container>
    );
  }
}

export default List;
